import { PrivacyAndTerms } from "../../components";

const Privacy = () => {
  return <PrivacyAndTerms title={"policy.title"} content={"policy.content"} />;
};

export default Privacy;
